import { showElement, hideElement } from './show-hide';

export function toggleArrow(anchorElem, fromCss, toCss, node = null) {
	const anchorMarker = node || anchorElem.querySelector('.anchor-marker');
	anchorMarker.classList.remove(fromCss);
	anchorMarker.classList.add(toCss);
}
export function showOptions(anchorElem, domElement) {
	// hide rest of checkbox dropdowns for
	// data-ref = checkbox-dropdown__items , .items
	const otherDrp = Array.from(document.querySelectorAll('.dropdown-check-list'));
	if (otherDrp.length > 1) {
		otherDrp.forEach(drp => {
			const selector = drp.classList.contains('multiselect-dropdown')
				? 'div.dropdown-expanded'
				: 'ul.items';
			const node = drp.querySelector('.anchor-marker');
			const dropDown = drp.querySelector(selector);
			hideElement(dropDown);
			toggleArrow(anchorElem, 'v2-arrow-indicator--up', 'v2-arrow-indicator--down', node);
		});
	}
	showElement(domElement);
	toggleArrow(anchorElem, 'v2-arrow-indicator--down', 'v2-arrow-indicator--up');
}
